import React from "react";
import './header.css';
import logo from '../../assets/sigma-epsilon.jpg';

const Header: React.FC = () => {
    return (
        <header>
            <a href='/' title="Sullen Entropy">
                <img src={logo} width='40' height='40'/>
            </a>
        </header>
    );
};

export default Header;